export const newsList = [
  {
    id: "n1",
    title: "年度华语电影市场观察：类型片迎来新拐点",
    category: "新闻",
    author: "四虎编辑组",
    date: "2026-09-28",
    cover: "https://readdy.ai/api/search-image?query=Modern%20cinema%20auditorium%20interior%20with%20rows%20of%20empty%20red%20seats%20and%20a%20glowing%20screen%2C%20deep%20navy%20and%20warm%20orange%20lighting%2C%20simple%20elegant%20background%2C%20editorial%20photography%2C%20high%20detail&width=800&height=480&seq=news-cover-01&orientation=landscape",
    summary: "过去一年，科幻、悬疑与现实主义题材成为市场主力，观众对优质类型片的需求持续上升，行业格局正在悄然改变。",
    content: [
      "过去一年，华语电影市场呈现出明显的结构性变化。以往占据票房头部的合家欢喜剧比例有所下降，而科幻、悬疑与现实题材作品则以更强的口碑扩散力完成了逆袭。",
      "业内人士分析，这一变化与观众审美升级密切相关。当流媒体让观众可以随时随地看到全球内容时，走进电影院的理由必须更充分——更震撼的视听体验、更独特的叙事，以及只能在银幕上获得的情绪冲击。",
      "与此同时，中小成本类型片也在今年找到了自己的位置。它们未必拥有顶级卡司，却凭借扎实的剧本与鲜明的地域气质赢得口碑，形成长线放映的良性循环。",
      "有制片人指出，接下来一年，如何在类型框架里讲述真正属于本土的故事，将是所有创作者共同面对的课题。",
    ],
  },
  {
    id: "n2",
    title: "深度影评：《幻影城市》里的城市寓言",
    category: "影评",
    author: "影评人 林一",
    date: "2026-09-25",
    cover: "https://readdy.ai/api/search-image?query=Futuristic%20neon%20city%20canyon%20at%20night%20seen%20from%20above%2C%20deep%20navy%20and%20teal%20with%20warm%20orange%20neon%20reflections%2C%20simple%20elegant%20background%2C%20editorial%20cinematic%20photography%2C%20high%20detail&width=800&height=480&seq=news-cover-02&orientation=landscape",
    summary: "当记忆可以交易、身份能够改写，《幻影城市》用一场赛博冒险追问：我们到底是数据，还是那个愿意为他人停留的人？",
    content: [
      "《幻影城市》表面是一部节奏凌厉的科幻动作片，内里却是一则关于城市的寓言。影片中的虚拟都市由无数数据构成，霓虹闪烁、秩序井然，却没有任何一个角落真正属于某个人。",
      "主角作为一名数据警探，工作的本质是维护系统的稳定。然而当他开始追查一桩失踪案，他逐渐发现，系统稳定的代价正是无数个体记忆的被抹除。",
      "影片最动人的段落并非动作场面，而是主角在虚拟与现实的交界处，试图记住一个快要消失的名字。那一刻，科技退居其次，情感成为唯一的证据。",
      "如果说城市是一种集体记忆，那么《幻影城市》提醒我们：真正让城市有温度的，从来不是它多么先进，而是有没有人愿意为另一段记忆停留。",
    ],
  },
  {
    id: "n3",
    title: "专题：流媒体时代，我们还需要电影院吗？",
    category: "专题",
    author: "四虎专题部",
    date: "2026-09-20",
    cover: "https://readdy.ai/api/search-image?query=Contrast%20of%20a%20glowing%20laptop%20screen%20in%20a%20dark%20room%20and%20a%20cinema%20screen%20reflection%2C%20deep%20navy%20tones%20with%20warm%20orange%20glow%2C%20simple%20elegant%20background%2C%20editorial%20photography%2C%20high%20detail&width=800&height=480&seq=news-cover-03&orientation=landscape",
    summary: "在家就能看到几乎一切内容，为什么还要走进影院？我们从观影体验、社交属性与内容生态三个角度谈了谈。",
    content: [
      "流媒体的崛起让观影变得前所未有的方便。打开电视、点开手机，几乎任何一部新片都能在不久后出现在你的客厅。于是那个老问题被反复提起：我们还需要电影院吗？",
      "第一个答案是体验。大银幕、环绕声与黑暗空间共同营造的沉浸感，是任何家用设备都难以完全复制的。当一部电影利用好这些条件，影院本身就成了作品的一部分。",
      "第二个答案是社交。看电影从来不只是看电影，它也是一种共同的仪式：约人、买票、等待开场，再一起讨论。这种共享的注意力，在碎片化的时代显得格外珍贵。",
      "当然，影院也必须进化。它会越来越多地承载那些真正值得大银幕的作品，而流媒体则负责满足日常的陪伴式观看。两者并非替代关系，而是分工。",
    ],
  },
  {
    id: "n4",
    title: "秋季档剧集前瞻：十部值得期待的国产剧",
    category: "新闻",
    author: "剧集观察员",
    date: "2026-09-16",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20autumn%20evening%20living%20room%20with%20a%20glowing%20tv%20screen%20and%20warm%20lights%2C%20deep%20navy%20shadows%20with%20warm%20orange%20ambient%20glow%2C%20simple%20elegant%20background%2C%20editorial%20photography%2C%20high%20detail&width=800&height=480&seq=news-cover-04&orientation=landscape",
    summary: "从古装权谋到都市现实，从悬疑推理到治愈日常，秋季档排播密集，我们挑出了十部最值得先加入待看清单的作品。",
    content: [
      "随着秋季档拉开帷幕，各平台的排播表迅速被填满。与往年相比，今年秋季档的类型分布更加均衡，既有大体量古装剧压阵，也有不少小而美的现实题材作品。",
      "悬疑推理依旧是热门赛道。多部作品选择在传统探案结构中融入家庭与情感议题，让“破案”不仅是智力游戏，也成为理解人性的入口。",
      "都市现实题材则更贴近当下。职场、代际关系、小城生活……创作者们把镜头对准了更具体的日常，试图在共鸣中寻找新的表达。",
      "值得一提的是，短剧集的数量明显增加。在观众注意力愈发宝贵的今天，能用十几集讲完一个完整故事的勇气，值得被看见。",
    ],
  },
  {
    id: "n5",
    title: "幕后：一部科幻片的诞生——特效团队访谈",
    category: "专题",
    author: "四虎专访",
    date: "2026-09-11",
    cover: "https://readdy.ai/api/search-image?query=Visual%20effects%20artist%20studio%20with%20large%20monitors%20showing%20space%20scenes%20and%20green%20screen%2C%20deep%20navy%20and%20teal%20interior%20with%20warm%20orange%20screen%20glow%2C%20editorial%20photography%2C%20high%20detail&width=800&height=480&seq=news-cover-05&orientation=landscape",
    summary: "银幕上一分钟的宇宙奇观，背后可能是特效团队半年的反复打磨。我们走进后期工作室，聊了聊画面之外的故事。",
    content: [
      "在观众眼中，科幻片最直观的魅力来自那些超越现实的画面。但在特效团队眼中，每一个镜头都是一次关于取舍的漫长谈判。",
      "团队负责人告诉我们，最难的部分从来不是让画面变得华丽，而是让它变得可信。哪怕是一个星云的旋转速度，也要经得起物理逻辑的推敲。",
      "为了控制成本与周期，团队大量使用了虚拟制片技术。演员在绿幕前表演，却能实时看到合成后的画面，这让表演与视觉之间产生了真正的互动。",
      "在被问及最满意的镜头时，负责人笑着说：“观众看完没有意识到那是特效，就是我们最大的成功。”",
    ],
  },
  {
    id: "n6",
    title: "影评：《时光信箱》如何讲述温柔的时间",
    category: "影评",
    author: "影评人 沈念",
    date: "2026-09-06",
    cover: "https://readdy.ai/api/search-image?query=Sunlit%20writing%20desk%20with%20old%20letters%20and%20a%20wooden%20box%20by%20an%20open%20window%2C%20warm%20cream%20and%20navy%20tones%20with%20orange%20afternoon%20light%2C%20editorial%20photography%2C%20high%20detail&width=800&height=480&seq=news-cover-06&orientation=landscape",
    summary: "《时光信箱》没有跌宕的转折，却用一个温柔的设定打动了很多人。它真正想说的，或许是如何与遗憾相处。",
    content: [
      "《时光信箱》的设定并不复杂：几句写信，就能寄给过去或未来的某个人。但影片没有把这种能力变成拯救一切的万能钥匙，反而处处克制。",
      "主角每一次试图改写过去，都会带来新的遗憾。影片借此表达了一个朴素的道理——真正需要被改变的，往往不是事件本身，而是我们看待它的方式。",
      "镜头语言同样温柔。导演大量使用自然光与静帧般的构图，让时间似乎在画面里慢了下来，与影片的主题高度契合。",
      "看完之后你会发现，它并不是一部关于穿越的电影，而是一部关于理解的电影。理解过去，也理解那个曾经做出选择的自己。",
    ],
  },
  {
    id: "n7",
    title: "行业观察：短视频如何改变影视宣发",
    category: "新闻",
    author: "行业观察组",
    date: "2026-09-02",
    cover: "https://readdy.ai/api/search-image?query=Hand%20holding%20a%20smartphone%20playing%20a%20vertical%20video%20against%20a%20blurred%20city%20night%2C%20deep%20navy%20tones%20with%20warm%20orange%20screen%20glow%2C%20editorial%20photography%2C%20high%20detail&width=800&height=480&seq=news-cover-07&orientation=landscape",
    summary: "从“名场面”剪辑到主创直播，短视频已经成为影视宣发不可忽视的一环。它带来了流量，也带来了新的挑战。",
    content: [
      "几年前，预告片还是影视宣发的核心物料。如今，一段三分钟的短视频剪辑，可能比正式预告更快地带动话题。",
      "这种变化背后是观众行为的迁移。人们越来越依赖碎片化的推荐来决定是否观看一部作品，而“前几秒能不能抓住人”成了新的创作法则。",
      "但与此同时，短视频宣发也带来了风险。过度剪辑容易造成预期错位，把观众吸引进影院后却让人失望，反而伤害长期口碑。",
      "如何在传播力与真实性之间找到平衡，成为宣发团队需要长期回答的问题。好的宣发，最终还是要为内容本身服务。",
    ],
  },
  {
    id: "n8",
    title: "经典重映：修复版《长风渡口》回归大银幕",
    category: "专题",
    author: "四虎编辑组",
    date: "2026-08-28",
    cover: "https://readdy.ai/api/search-image?query=Classic%20old%20film%20projector%20casting%20light%20in%20a%20dark%20vintage%20cinema%2C%20deep%20navy%20shadows%20with%20warm%20orange%20beam%2C%20editorial%20photography%2C%20high%20detail&width=800&height=480&seq=news-cover-08&orientation=landscape",
    summary: "经过修复，这部经典剧集以更高画质重返大银幕。老作品为何值得被一再重看？或许答案藏在每一代观众的共鸣里。",
    content: [
      "修复一部老作品，远比想象中复杂。团队需要逐帧清理画面损伤，重新校准色彩，甚至找回当年的原始音轨，只为让作品更接近它最初的样子。",
      "《长风渡口》之所以被视为经典，不仅因为它的故事，更因为它记录了一个时代的美学与情感。多年后重看，观众会发现自己关注的东西已经不同。",
      "这也是重映的意义所在：经典不是博物馆里的标本，而是可以被一代又一代人重新阅读的文本。每一次重看，都是一次新的相遇。",
      "本次修复版将陆续在部分影院限量放映，同时上线高清版本，方便更多观众在家重温。",
    ],
  },
];

export const newsCategories = ["全部", "新闻", "影评", "专题"];